import Comparison from './Comparison'

export default class LessThan extends Comparison {
  get ruleName () {
    return 'lessThan'
  }

  passesStringOrArray () {
    return this.value.length < parseInt(this.number)
  }

  passesNumber () {
    return this.value < parseFloat(this.number)
  }

  passesString () {
    return this.passesStringOrArray()
  }

  passesArray () {
    return this.passesStringOrArray()
  }
}
